import { render, staticRenderFns } from "./DrivewealthNavigation.vue?vue&type=template&id=46797fc8&scoped=true"
import script from "./DrivewealthNavigation.vue?vue&type=script&lang=ts"
export * from "./DrivewealthNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46797fc8",
  null
  
)

export default component.exports